import CreateInterview from '@Application/Beneficiaries/Interviews/Commands/CreateInterview';
import { InterviewKind } from '@Domain/Enums/Interviews/InterviewKind';
import PlainDate from '@Domain/PlainDate';
import type { LocalInterview } from '@Domain/Ports/LocalInterviews/LocalInterviewPort';

/**
 * Builds the composite create command from a local interview, or `null` when its date is unreadable.
 * `name` and `kind` are optional on a local interview but required by the server: a record with
 * neither falls back to a date-based label and to the most common kind.
 */
const buildCreateInterview = (localInterview: LocalInterview): CreateInterview | null => {
	const conductedOn = PlainDate.fromApi(localInterview.conductedOn);

	if (conductedOn === null) {
		return null;
	}

	return new CreateInterview(
		localInterview.facilityId,
		localInterview.subject,
		localInterview.id,
		localInterview.name ?? `Entretien du ${conductedOn.toDisplay()}`,
		localInterview.kind ?? InterviewKind.CONVERSATION,
		conductedOn,
		localInterview.participants,
		localInterview.consentGrantedAt,
		localInterview.source,
		localInterview.preparationId ?? null,
		localInterview.participantsInformedAt ?? null,
	);
};

export default buildCreateInterview;
